import { Button, Checkbox, Col, Divider, Modal, Row, Tag } from "antd";
import { useEffect, useMemo, useState } from "react";
import Autocomplete from "react-google-autocomplete";
import { IoMdClose } from "react-icons/io";
import searchIcon from "../../../assets/images/searchIcon.png";
import "./CommonFIlterModal.scss";

const CommonFIlterModal = ({
  visible,
  onClose,
  onApply,
  onReset,
  filters,
  selectedCategory,
  setSelectedCategory,
  selectedValues,
  setSelectedValues,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleCheckboxChange = (checked, value) => {
    setSelectedValues((prev) => {
      const currentList = prev[selectedCategory] || [];
      const updatedList = checked
        ? [...currentList, value]
        : currentList.filter((v) => v !== value);

      return { ...prev, [selectedCategory]: updatedList };
    });
  };

  const filteredOptions =
    filters[selectedCategory]?.filter((opt) =>
      opt.toLowerCase().includes(searchTerm.toLowerCase()),
    ) || [];

  const handleRemoveItem = (filterKey, value) => {
    setSelectedValues((prev) => {
      const current = prev[filterKey] || [];
      return {
        ...prev,
        [filterKey]: current.filter((v) => v !== value),
      };
    });
  };

  const filtersCount = useMemo(
    () =>
      Object.keys(selectedValues).filter((key) => selectedValues[key]?.length)
        .length,
    [selectedValues],
  );

  useEffect(() => {
    if (visible) {
      setSearchTerm("");
    }
  }, [visible]);

  return (
    <Modal
      title="Filters"
      open={visible}
      closeIcon={<IoMdClose onClick={onClose} size={25} />}
      footer={null}
      width={800}
      centered
      className="filter-sidebar-modal"
    >
      <Divider />
      <Row gutter={16}>
        {/* Left Panel: Categories */}
        <Col span={7}>
          <div className="filter-sidebar-categories">
            {Object.keys(filters).map((category) => (
              <div
                key={category}
                className={`filter-category-item ${selectedCategory === category ? "active" : ""}`}
                onClick={() => {
                  setSelectedCategory(category);
                  setSearchTerm("");
                }}
              >
                {category}
              </div>
            ))}
          </div>
        </Col>

        {/* Middle Panel: Checkbox Options */}
        <Col span={9} style={{ height: 400, overflowY: "auto" }}>
          <div
            style={{
              position: "sticky",
              top: 0,
              background: "#fff",
              zIndex: 10,
              // paddingBottom: 8,
              // paddingTop: 8,
            }}
          >
            {selectedCategory === "City / Town" ? (
              <Autocomplete
                apiKey="AIzaSyBJUZFe3zt4HNVzwdTlmJYMWtXhZ7mfclk"
                onPlaceSelected={(place) => {
                  const city = place?.formatted_address;
                  if (city) {
                    setSelectedValues((prev) => {
                      const currentList = prev["City / Town"] || [];
                      if (currentList.includes(city)) return prev; // Avoid duplicates
                      return {
                        ...prev,
                        "City / Town": [...currentList, city],
                      };
                    });
                  }
                }}
                types={["(cities)"]}
                className="form-control newlocation"
                defaultValue=""
                placeholder="Search City / Town..."
                componentRestrictions={{ country: "us" }}
              />
            ) : (
              <div className="searchInputWrapper position-relative mb-3">
                <div
                  className="searchImg position-absolute"
                  style={{ top: "15%", left: "3%" }}
                >
                  <img src={searchIcon} alt="search" />
                </div>
                <div className="searchInputText">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control px-5 h-100"
                    onChange={(e) => setSearchTerm(e.target.value)}
                    // allowClear
                  />
                </div>
              </div>
            )}
          </div>

          <div className="filter-checkbox-list" style={{ paddingTop: 8 }}>
            {selectedCategory !== "City / Town" &&
              filteredOptions.map((item) => (
                <Checkbox
                  key={item}
                  checked={selectedValues[selectedCategory]?.includes(item)}
                  onChange={(e) => handleCheckboxChange(e.target.checked, item)}
                >
                  {item}
                </Checkbox>
              ))}
          </div>
        </Col>

        {/* Right Panel: Applied Filters */}
        <Col
          span={8}
          style={{
            height: 400,
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <div className="d-flex justify-content-between align-items-center mb-2">
            <strong>{filtersCount} Filters Applied</strong>
            <Button type="link" onClick={onReset}>
              Clear All
            </Button>
          </div>

          {Object.keys(selectedValues).map((filterKey) =>
            selectedValues[filterKey]?.length > 0 ? (
              <div key={filterKey} className="mb-2">
                <div className="fw-bold">{filterKey}</div>
                {selectedValues[filterKey].map((value) => (
                  <Tag
                    key={value}
                    closable
                    closeIcon={<IoMdClose size={16} />}
                    className="text-nowrap fs14fw500 m-2 px-2 py-1 border-0"
                    onClose={() => handleRemoveItem(filterKey, value)}
                    style={{
                      backgroundColor: "#FAE8EF",
                    }}
                  >
                    {value}
                  </Tag>
                ))}
              </div>
            ) : null,
          )}
        </Col>
      </Row>

      <div style={{ textAlign: "right", marginTop: 16 }}>
        <Button onClick={onReset} className="me-2">
          Reset Filters
        </Button>
        <Button
          type="primary"
          onClick={onApply}
          style={{
            borderRadius: "5px",
            padding: "0 20px",
          }}
        >
          Apply
        </Button>
      </div>
    </Modal>
  );
};

export default CommonFIlterModal;
